import * as React from 'react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import { createRecordUrl, ViewType } from 'utils/formatter';
import { RecordType } from 'api/artikelDetailHistorie';

const styles = mergeStyleSets({
    openInNewTab: {
        textDecoration: 'underline',
        cursor: 'pointer',
    },
});

interface OpenLinkIconProps {
    className?: string;
    label: string;
    link: string;
    runBefore?: () => void;
}

export function OpenLink({ className, link, label, runBefore = () => {} }: OpenLinkIconProps): JSX.Element {
    const history = useHistory();

    return (
        <div
            className={classnames(styles.openInNewTab, className)}
            onClick={(event) => {
                event.preventDefault();
                if (runBefore && !event.ctrlKey && !event.metaKey) {
                    runBefore();
                }
                setTimeout(() => {
                    if (event.ctrlKey || event.metaKey) {
                        window.open(link);
                    } else {
                        history.push(link);
                    }
                }, 100);
            }}
        >
            {label}
        </div>
    );
}

export function getRecordOpenLink(
    recordType?: RecordType,
    recordNr?: string,
    kNr?: number,
    className?: string,
    label?: string,
): React.ReactElement | null {
    if (!recordType || !recordNr) {
        return null;
    }

    const view = {
        angebot: 'angebote',
        auftrag: 'auftraege',
        bestellung: 'bestellungen',
        lieferung: 'lieferungen',
        rechnung: 'rechnungen',
    }[recordType];

    const link = createRecordUrl(view as ViewType, kNr, recordNr);

    return <OpenLink className={className} link={link} label={label || recordNr} />;
}
